module.exports = __webpack_public_path__ + "img/co_bg2.fc37f1aa.png";